import React, { useState } from 'react';
import { IonIcon } from '@ionic/react';
import { arrowDownOutline, arrowUpOutline } from 'ionicons/icons';
import './FaqItem.css';

interface Faq {
    title: string;
    description: string;
}

interface FaqItemProps {
    faq: Faq;
}

const FaqItem: React.FC<FaqItemProps> = ({ faq }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggleOpen = () => setIsOpen(!isOpen);

    return (
        <div className="faq-item">
            <div 
                className="faq-question"
                tabIndex={0} // for keyboard navigation
                aria-expanded={isOpen} // for accessibility
                onClick={toggleOpen}
            >
                {faq.title}
                <IonIcon icon={isOpen ? arrowUpOutline : arrowDownOutline} className="faq-icon" />
            </div>
            <div className={`faq-answer ${isOpen ? 'open' : ''}`}>{faq.description}</div>
        </div>
    );
}

interface FaqListProps {
    faqData: Array<{[key: string]: Faq}>;
    lang: string;
}

const FaqList: React.FC<FaqListProps> = ({ faqData, lang }) => {
    return (
        <div>
            {faqData.map((faq, index) => (
                <FaqItem key={`${faq[lang].title}-${index}`} faq={faq[lang]} />
            ))}
        </div>
    );
}

export default FaqList;
